export default __webpack_public_path__ + "static/media/product-image-22.c23081a4.jpg";